import * as Yup from "yup";
import { joiEmailSchema } from "../../../utils/utils";

// BASIC INFORMATION VALIDATION SCHEMA
export const basicInfoFormValidationSchema = Yup.object({
  businessName: Yup.string()
    .max(30, "Maximum 30 characters allowed")
    .required("Business/Provider Name is required"),
  contactEmail: Yup.string()
    .email("Invalid email format")
    .max(50, "Maximum 50 characters allowed")
    .required("Email is required")
    .test("joi-email-check", "Invalid email format", function (value) {
      if (!value) return false;
      const { error } = joiEmailSchema.validate(value);
      return !error;
    }),
  contactPhone: Yup.string().required("Contact Number is required"),
  contactName: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only alphabetic characters allowed")
    .max(30, "Maximum 30 characters allowed")
    .required("Contact Person Name is required"),
  contactPosition: Yup.string()
    .matches(/^[A-Za-z\s-]*$/, "Only alphabetic characters and hyphens allowed")
    .max(30, "Maximum 30 characters allowed"),
  businessDescription: Yup.string()
    .max(500, "Maximum 500 characters allowed")
    .required("Detailed Description is required"),
});

// BANK INFORMATION VALIDATION SCHEMA
export const bankInfoValidationSchema = Yup.object({
  bankTaxProfileEIN: Yup.string()
    .max(30, "Maximum 30 characters allowed")
    .required("Tax Profile/EIN is required"),
  bankAccountType: Yup.string().required("Account Type is required"),
  bankAccountHolderName: Yup.string()
    .max(30, "Maximum 30 characters allowed")
    .required("Account Holder Name is required"),
  bankRoutingNumberABA: Yup.string().matches(
    /^\d{10}$/,
    "Routing Number must be 10 digits",
  ),
  bankAccountNumber: Yup.string()
    .matches(/^\d+$/, "Account Number must be digits only")
    .max(30, "Maximum 30 characters allowed")
    .required("Account Number is required"),
  w9Form: Yup.mixed().required("W9 Form is required"),
});
